import { 
	ContainerSoftware16,
} from '@carbon/icons';


export default [
	/* **** */
	{
		path: '/system',
		redirect: '/system/events',
		layout: 'Admin',
		meta: {
			name: 'Система',
			icon: ContainerSoftware16,
		},
		menu: true,
		permissions: [ 'system_event', 'system_role' ],
		children: [
			{
				path: '/events',
				component: 'SystemEvents',
				meta: {
					name: 'События',
				},
				menu: true,
				permissions: [ 'system_event' ],
			},
			{
				path: '/events/:id/notices/templates',
				component: 'SystemNoticesTemplates',
				meta: {
					name: 'Шаблоны уведомлений',
				},
				menu: false,
				permissions: [ 'system_event' ],
			},
			{
				path: '/roles',
				component: 'SystemRoles',
				meta: {
					name: 'Роли',
				},
				menu: true,
				permissions: [ 'system_role' ],
			},
			{
				path: '/roles/:id/rules',
				component: 'SystemRoleRules',
				meta: {
					name: 'Правила доступа для роли',
				},
				menu: false,
				permissions: [ 'system_role' ],
			},
			{
				path: '/roles/:id/notices',
				component: 'SystemRoleNotices',
				meta: {
					name: 'Настройка уведомлений для роли',
				},
				menu: false,
				permissions: [ 'system_role' ],
			},
		],
	},
	/* **** */
];
